import { CommonModule } from '@angular/common';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgcCommonModule } from '../../common/common.module';
// This Module's Components
import { FlyoutLangSelectConfirmationComponent } from './flyout-lang-select-confirmation.component';

@NgModule({
  imports: [FormsModule, ReactiveFormsModule, NgcCommonModule, CommonModule],
  declarations: [FlyoutLangSelectConfirmationComponent],
  exports: [FlyoutLangSelectConfirmationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FlyoutLangSelectConfirmationModule {}
